/** First URL segment reserved for marketing app routes — not teacher portfolio slugs */
export const RESERVED_ROOT_SEGMENTS = new Set([
  'login',
  'forgot-password',
  'reset-password',
  'signup',
  'billing',
  'features',
  'pricing',
  'partnerships',
  'contact',
  'about',
  'privacy-policy',
  'terms-and-conditions',
  'cookie-policy',
  'refund-policy',
  'how-it-works',
  'blogs',
  'promo',
]);

/** True when Arrangelly marketing header/footer should show (portfolio uses its own chrome). */
export function shouldShowMarketingShell(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) {
    return true;
  }

  const first = segments[0]?.toLowerCase() ?? '';
  if (RESERVED_ROOT_SEGMENTS.has(first)) {
    return true;
  }

  const isPortfolioChrome =
    segments.length === 1 ||
    (segments.length === 3 && segments[1]?.toLowerCase() === 'blogs');

  return !isPortfolioChrome;
}
